export const ConstantConfig = {
    Role: {
        Trainer: "TRAINER",
        Trainee: "TRAINEE",
        Supervisor: "SUPERVISOR"
    },
    ImpellaGuru: {
        DisplayText: "Playground A",
        ApiText: "ImpellaGuru",
        About: "ImpellaGuru"
    },
    ClinicalGuru: {
        DisplayText: "Playground B",
        ApiText: "ClinicalDataGuru",
        About: "ClinicalDataGuru"
    },
    RolePlay: {
        DisplayText: "Roleplay",
        ApiText: "role-play",
        About: "Roleplay"
    }
}

export const errorPhrases = [
    'I am sorry',
    "I'm sorry",
    'An unexpected error',
    'invalid syntax',
    'Invalid expression',
    'The user session has expired',
    'rephrase the question',
    'Could you please clarify',
    '申し訳ありません',
    'ごめんなさい',
    '予期しないエラー',
    '無効な構文',
    '無効な式',
    'ユーザーセッションが期限切れになりました',
    '質問を言い換えてください',
    'もう一度質問を明確にしてください',
    'ご質問を明確にしていただくか、直接HCCへご連絡ください。'];

export const refDocHideForRoleLabel = ['TRAINEE', 'TRAINER']

export const searchString = "Error code: 401";

export const EXP_DATE_MSG = 'Please select expiry date';

export const SESSION_EXP_ERROR = 'The user session has expired. Please log out from the application and log in again.';

export const DASHBOARD_INFO = 'This Power BI Dashboard page is currently under development.'

export const SPECIALITY_INFO_MSG = 'Atleast one speciality is required. If speciality is empty, considering as all specialities are selected'

// PROD URL
export const URL_SUBMIT_AN_ISSUE = 'https://apps.powerapps.com/play/e/default-3ac94b33-9135-4821-9502-eafda6592a35/a/1c06b57c-cb00-4d28-96e8-46640464948d?tenantId=3ac94b33-9135-4821-9502-eafda6592a35';

// QA URL
// export const URL_SUBMIT_AN_ISSUE = 'https://apps.powerapps.com/play/e/default-3ac94b33-9135-4821-9502-eafda6592a35/a/61acd12e-253d-4b00-86fc-c7d0d52d71a4?tenantId=3ac94b33-9135-4821-9502-eafda6592a35&sourcetime=1753234230701&source=monitor&screenColor=rgba%28235%2C+23%2C+0%2C+1%29&mep=https%3A%2F%2Fauthoring.eus-il105.gateway.prod.island.powerapps.com%2Fv3.25071.7.339065824&mjt=AQkzaGOCs4aAMXu7edllcvpT5YeAfuoZzm6e0dpsXeuiui_qZVTa2QKsDYeFa0p0q4rSAUQimjSYQbSlukoTKnoN4eTPaepUHLZR5tKDTRVIQ7n5H0BJmgduygGrcBHy_5CtrPO8tLMST8d7mQJiph6O2sXYOjVMLYHDiZuMOiDgIVksahu3hFyX9ORxWMDBJKV21yW_Xcv9hCHRwxELw6pxIPZG-n3FG0pzWRNUG4clQVMpE5W_X0r3kJOXF1u5kNcR-v2MhQBMMwVfMjbYUDxKxe3dWq6dxlbpq2pDYVJAtZw5sTE-Pr8CLbdmYbgqqPgFv2xfmXzvjcXLojhRR301JOQgADg4U6ibqrESFTgAsNlnreyRJG2wkT0wDvbTLESSN2PTVJD2a-tkC20s1F7SdBmttG2OVB_p7iwGrN8aNtQq9WK_lAhvTkgBbrjIEQ0Vc7KWqPnJ9I_pr-cu8dHjJ-htF_Y-ugD9_d7qci2xldhAXHUeaKIIDQRDztXbLK4d1nl1uv_O-tyogyBu9gX_HEW1w410ZECihQxq7tp4MQTm9cafJs43zw9s0ECCj8WG6_3ZTWJnD8Smgjst4iaTq55_Ec1djHnRvfwoR0RD&mts=play';

//const baseUrl = "https://apps.powerapps.com/play/e/default-3ac94b33-9135-4821-9502-eafda6592a35/a/61acd12e-253d-4b00-86fc-c7d0d52d71a4?tenantId=3ac94b33-9135-4821-9502-eafda6592a35&sourcetime=1753234230701&source=monitor&screenColor=rgba%28235%2C+23%2C+0%2C+1%29&mep=https%3A%2F%2Fauthoring.eus-il105.gateway.prod.island.powerapps.com%2Fv3.25071.7.339065824&mjt=AQkzaGOCs4aAMXu7edllcvpT5YeAfuoZzm6e0dpsXeuiui_qZVTa2QKsDYeFa0p0q4rSAUQimjSYQbSlukoTKnoN4eTPaepUHLZR5tKDTRVIQ7n5H0BJmgduygGrcBHy_5CtrPO8tLMST8d7mQJiph6O2sXYOjVMLYHDiZuMOiDgIVksahu3hFyX9ORxWMDBJKV21yW_Xcv9hCHRwxELw6pxIPZG-n3FG0pzWRNUG4clQVMpE5W_X0r3kJOXF1u5kNcR-v2MhQBMMwVfMjbYUDxKxe3dWq6dxlbpq2pDYVJAtZw5sTE-Pr8CLbdmYbgqqPgFv2xfmXzvjcXLojhRR301JOQgADg4U6ibqrESFTgAsNlnreyRJG2wkT0wDvbTLESSN2PTVJD2a-tkC20s1F7SdBmttG2OVB_p7iwGrN8aNtQq9WK_lAhvTkgBbrjIEQ0Vc7KWqPnJ9I_pr-cu8dHjJ-htF_Y-ugD9_d7qci2xldhAXHUeaKIIDQRDztXbLK4d1nl1uv_O-tyogyBu9gX_HEW1w410ZECihQxq7tp4MQTm9cafJs43zw9s0ECCj8WG6_3ZTWJnD8Smgjst4iaTq55_Ec1djHnRvfwoR0RD&mts=play";
export const DOCUMENT_NUMBER = 3

export const MAX_FILE_SIZE_BYTES = 20 * 1024 * 1024; // 20MB

export const PLAYGROUND_ENABLED_ROLES = ['TRAINER', 'SUPERVISOR']

export const PLAYGROUND_B_ENABLED_ROLES = ['SUPERVISOR']

export const ENABLE_SYSTEM_PROMPT_TYPE = ['playground']

export const ENABLE_PLAYGROUND_PROMPT_ROLE = ['TRAINER']

export const DEFAULT_PLATFORM_LABEL = "AI Advisor - Beta"

export const GRAPH_ENDPOINT_PROFILE_IMAGE = 'https://graph.microsoft.com/v1.0/me/photo/$value';

export const BUSINESS_FAQ_ROLE = ['SUPERVISOR', 'TRAINER']

export const CHAT_DISABLED_BUSINESS_UNITS = ['JR', 'TR']